module.exports = __webpack_public_path__ + "static/img/picc2.0773bd2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/picc2.png
// module id = j3gd
// module chunks = 0